import PropTypes from "prop-types"
import { TableRow, TableCell } from "@mui/material"

export default function NoContributionsRow({ customMessage = "No significant contributions were found.", colSpan = 3 }) {
  return (
    <TableRow className="components_no-contributions-row">
      <TableCell colSpan={colSpan} align="center">
        {customMessage}
      </TableCell>
    </TableRow>
  )
}

NoContributionsRow.propTypes = {
  customMessage: PropTypes.string,
  colSpan: PropTypes.number,
}
